import React from 'react';
import GlowCard from './GlowCard';
import Reveal from './Reveal';

const SectionIcon = ({ children }) => (
  <span className="inline-flex h-10 w-10 items-center justify-center rounded-xl border border-brand/40 bg-brand/10 text-brand">
    {children}
  </span>
);

const StreamingIcon = () => (
  <svg viewBox="0 0 24 24" className="h-5 w-5" fill="none" stroke="currentColor" strokeWidth="1.9">
    <rect x="3" y="5" width="18" height="12" rx="2" />
    <path d="M9 9.2V13.8L14 11.5L9 9.2Z" fill="currentColor" stroke="none" />
    <path d="M8.5 19.2H15.5" />
  </svg>
);

const ServerIcon = () => (
  <svg viewBox="0 0 24 24" className="h-5 w-5" fill="none" stroke="currentColor" strokeWidth="1.9">
    <rect x="4" y="4" width="16" height="5" rx="1.4" />
    <rect x="4" y="10" width="16" height="5" rx="1.4" />
    <rect x="4" y="16" width="16" height="4" rx="1.4" />
    <circle cx="8" cy="6.5" r="0.8" fill="currentColor" stroke="none" />
    <circle cx="8" cy="12.5" r="0.8" fill="currentColor" stroke="none" />
    <circle cx="8" cy="18" r="0.8" fill="currentColor" stroke="none" />
  </svg>
);

const ShieldIcon = () => (
  <svg viewBox="0 0 24 24" className="h-5 w-5" fill="none" stroke="currentColor" strokeWidth="1.9">
    <path d="M12 3.8L18.5 6.2V11.4C18.5 15.4 16.1 18.6 12 20.2C7.9 18.6 5.5 15.4 5.5 11.4V6.2L12 3.8Z" />
    <path d="M9.2 12.1L11.1 14L14.9 10.2" />
  </svg>
);

const SpeedIcon = () => (
  <svg viewBox="0 0 24 24" className="h-5 w-5" fill="none" stroke="currentColor" strokeWidth="1.9">
    <path d="M5 15a7 7 0 1 1 14 0" />
    <path d="M12 12L16.3 9.7" />
    <path d="M7 18H17" />
  </svg>
);

const points = [
  {
    title: 'Multiples servidores de streaming',
    text: 'Distribuimos la carga en varios nodos para mejorar estabilidad y continuidad del servicio.',
    Icon: ServerIcon,
  },
  {
    title: 'Mejor alternativa de costo y calidad',
    text: 'Un solo servicio con canales, deportes y catalogo premium para simplificar tu entretenimiento.',
    Icon: SpeedIcon,
  },
  {
    title: 'Servicio confiable para toda la familia',
    text: 'Diseno orientado a una experiencia estable en TV, box, celular y computador.',
    Icon: ShieldIcon,
  },
];

const AboutStreaming = () => {
  return (
    <section className="mx-auto max-w-6xl px-4 pb-10 pt-4 md:px-6">
      <GlowCard as="article" className="relative overflow-hidden rounded-3xl border border-brand/30 bg-surface-800/90 p-7 shadow-[0_24px_44px_rgba(0,0,0,0.38)]">
        <div className="absolute -right-24 -top-20 h-52 w-52 rounded-full bg-brand/20 blur-3xl" />
        <div className="absolute -bottom-24 -left-24 h-56 w-56 rounded-full bg-brand-soft/10 blur-3xl" />

        <div className="relative">
          <Reveal delay={40}>
            <div className="mb-4 flex items-center gap-3">
              <SectionIcon>
                <StreamingIcon />
              </SectionIcon>
              <h2 className="font-display text-2xl font-bold text-text-100 md:text-3xl">Sobre Nosotros</h2>
            </div>
          </Reveal>

          <Reveal delay={130}>
            <p className="max-w-3xl text-sm text-text-300 md:text-base">
              El streaming moderno es la mejor opcion para tener contenido bajo demanda, eventos en vivo y acceso
              multiplataforma desde cualquier lugar. En GORDITO TV enfocamos nuestro servicio en estabilidad, soporte y
              rendimiento real para que la experiencia sea continua.
            </p>
          </Reveal>

          <div className="mt-6 grid gap-4 md:grid-cols-3">
            {points.map(({ title, text, Icon }, index) => (
              <Reveal key={title} delay={80 + index * 120}>
                <GlowCard className="rounded-2xl border border-brand/20 bg-surface-700/75 p-4 transition duration-200 hover:-translate-y-0.5 hover:border-brand/45">
                <span className="mb-3 inline-flex h-9 w-9 items-center justify-center rounded-lg bg-brand/15 text-brand">
                  <Icon />
                </span>
                <h3 className="font-display text-lg font-bold text-text-100">{title}</h3>
                <p className="mt-2 text-sm text-text-300">{text}</p>
                </GlowCard>
              </Reveal>
            ))}
          </div>
        </div>
      </GlowCard>
    </section>
  );
};

export default AboutStreaming;
